/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'equals': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g stroke-width="2" _stroke="currentColor"><path pid="0" d="M2 6h12M2 11h12"/></g>'
  }
})
